import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncReportingModule as MncReportingModule } from '@app/mnc-reporting.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('REPORTING UI Version:', {
  buildNumber,
  commit,
})

platformBrowserDynamic()
  .bootstrapModule(MncReportingModule, {
    applicationProviders: [provideZoneChangeDetection()],
    providers: [{ provide: LOCALE_ID, useValue: 'en-US' }]
  })
  .catch((err) => console.error(err));
